import { createCombineMapItem } from '../../../../../reducerRegistry';

import { createReduceObject as createListReduceObject } from '../../../../../common/reducers/list/reducer';

import userRatingStatusesSaga from './sagas/userRatingStatusesSaga';
import userRatingPointsHistorySaga from './sagas/userRatingPointsHistorySaga';

export default [
  // Lists
  ...createCombineMapItem('userRatingStatusesList', createListReduceObject, [
    userRatingStatusesSaga
  ]),
  ...createCombineMapItem(
    'userRatingPointsHistoryList',
    createListReduceObject,
    [userRatingPointsHistorySaga]
  )
];



// WEBPACK FOOTER //
// ./src/mt-react-common/modules/userRating/reducers/static/lists/reducersMap.js